import {Input} from "antd";
import {LanguageDefaultSwitchStyles} from "./LanguageDefaultSwitch.styles"
import cl from "classnames";
import {useLang} from "../../../hooks";
import {LANG_KEY} from "../../../constants";

export const LanguageDefaultSwitch = () => {
  const {lang, handleChangeLang} = useLang()
  const handleChangeLangInput = (val: boolean) => {
    if (val) {
      handleChangeLang(LANG_KEY.KZ)
    } else {
      handleChangeLang(LANG_KEY.RU)
    }
  }

  return (
    <LanguageDefaultSwitchStyles>
      <input id="language-toggle" className={cl('checkToggle', 'checkToggleRoundFlat')} type="checkbox"
             checked={lang === LANG_KEY.KZ} onChange={(e) => handleChangeLangInput(e.target.checked)}/>
      <label htmlFor="language-toggle">
        <span className={cl('on')}>KZ</span>
        <span className={cl('off')}>RU</span>
      </label>
    </LanguageDefaultSwitchStyles>
  )
}